import React from 'react';

const MissionStatement: React.FC = () => {
  return (
    <div className="mission-statement">
      <div className="mission-content">
        <h2 className="mission-title">
          Empowering E-Commerce Excellence Through Automation
        </h2>
        <p className="mission-text">
          At Easy Street Brands, we believe that the future of e-commerce lies in intelligent automation. 
          Our mission is to transform how Mars Men and Hollow Socks operate by building powerful tools that 
          eliminate repetitive tasks, unlock data-driven insights, and enable our teams to focus on what 
          truly matters: <strong>creativity, strategy, and growth</strong>.
        </p>
        <div className="mission-pillars">
          <div className="pillar">
            <span className="pillar-icon">🎯</span>
            <h3>Data-Driven Decisions</h3>
            <p>Transform customer feedback and analytics into actionable insights</p>
          </div>
          <div className="pillar">
            <span className="pillar-icon">⚡</span>
            <h3>Operational Efficiency</h3>
            <p>Automate repetitive tasks to free up time for strategic initiatives</p>
          </div>
          <div className="pillar">
            <span className="pillar-icon">🚀</span>
            <h3>Scalable Growth</h3>
            <p>Build systems that grow with our brands and adapt to new challenges</p>
          </div>
        </div>
        <p className="mission-footer">
          One automation at a time, we're building the infrastructure that will power the next generation 
          of direct-to-consumer brands. Every tool we create, every process we optimize, brings us closer 
          to a future where technology amplifies human creativity rather than replacing it.
        </p>
      </div>
    </div>
  );
};

export default MissionStatement;